import React from 'react';
import PropTypes from 'prop-types';

import CardBlock from 'components/CardBlock';
import Container from 'components/Container';
import SpecialProjectCard from 'components/cards/entities/SpecialProjectCard';
import Section from 'components/Section';

import { EntitiesPropType } from 'propTypes/common';

const SpecialProjects = ({ entities, subtitle }) => (
	<Section
		title="Спецпроекты"
		align="center"
		titleSize="medium"
		subtitle={subtitle}
	>
		<Container width="landingSlider">
			<CardBlock entities={entities} Card={SpecialProjectCard} />
		</Container>
	</Section>
);

SpecialProjects.propTypes = {
	entities: EntitiesPropType.isRequired,
	subtitle: PropTypes.string
};

export default SpecialProjects;
